import './index.css';
import LandingPage from './components/LandingPage';
import { useState, useEffect } from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import Docs from './components/Docs.jsx';
import Sidebar from './components/sub-components/Sidebar.jsx';
import Navbar from './components/sub-components/Navbar.jsx';

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isMobile;
}

function SidebarLayout({ ActiveDocs, SetActiveDocs, sidebarOpen, setSidebarOpen }) {
  const isMobile = useIsMobile();

  return (
    <div className="min-h-screen bg-[#0D0D0D]">
      {/* Shared top navbar — consistent across all pages */}
      <Navbar
        SetActiveDocs={SetActiveDocs}
        activeSection=""
        setIsOpen={setSidebarOpen}
        showSidebarToggle={isMobile}
        onSidebarToggle={() => setSidebarOpen(!sidebarOpen)}
      />

      <div className="flex">
        {/* Sidebar */}
        <Sidebar
          setIsOpen={setSidebarOpen}
          isopen={sidebarOpen}
          active={ActiveDocs}
          setactive={SetActiveDocs}
        />

        {/* Main content — offset for desktop sidebar */}
        <main className={`flex-1 min-w-0 text-[#E0E0E0] transition-all duration-300 ${!isMobile ? 'mr-64' : ''}`}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}

function App() {
  const [activeSection, setActiveSection] = useState('hero');
  const [ActiveDocs, SetActiveDocs] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('section')
      ? decodeURIComponent(params.get('section'))
      : 'ليه تدرس في امريكا';
  });

  const goToSection = (section) => {
    SetActiveDocs(section);
    const params = new URLSearchParams(window.location.search);
    params.set('section', section);
    window.history.replaceState(
      null,
      '',
      `${window.location.pathname}?${params.toString()}${window.location.hash}`
    );
  };
    const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#0D0D0D]">
      <Routes>
        <Route
          path="/"
          element={
            <LandingPage
              handler={setActiveSection}
              activeSection={activeSection}
              setIsOpen={setSidebarOpen}
              SetActiveDocs={goToSection}
            />
          }
        />
        <Route
          path="/Docs"
          element={
            <SidebarLayout
              ActiveDocs={ActiveDocs}
              SetActiveDocs={goToSection}
              sidebarOpen={sidebarOpen}
              setSidebarOpen={setSidebarOpen}
            />
          }
        >
          <Route index element={<Docs activesection={ActiveDocs} />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
